import React from 'react';
import { Helmet } from 'react-helmet';

export default function SEO() {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Kesari Glow - Premium Indian Skincare & Cosmetics | kesariglow.in</title>
      <meta name="title" content="Kesari Glow - Premium Indian Skincare & Cosmetics | kesariglow.in" />
      <meta name="description" content="Discover premium Indian skincare products at Kesari Glow. Experience the power of traditional Indian beauty secrets combined with modern skincare innovation. Shop now at kesariglow.in" />
      
      {/* Keywords */}
      <meta name="keywords" content="Kesari Glow, Indian skincare, premium cosmetics, luxury beauty products, natural skincare, traditional beauty, saffron skincare, organic cosmetics, Indian beauty secrets, premium beauty products, kesariglow.in" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://kesariglow.in/" />
      <meta property="og:title" content="Kesari Glow - Premium Indian Skincare & Cosmetics" />
      <meta property="og:description" content="Experience luxury skincare inspired by Indian heritage. Premium cosmetics crafted with traditional wisdom and modern innovation." />
      <meta property="og:image" content="https://kesariglow.in/og-image.jpg" />
      <meta property="og:site_name" content="Kesari Glow" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://kesariglow.in/" />
      <meta property="twitter:title" content="Kesari Glow - Premium Indian Skincare & Cosmetics" />
      <meta property="twitter:description" content="Experience luxury skincare inspired by Indian heritage. Premium cosmetics crafted with traditional wisdom and modern innovation." />
      <meta property="twitter:image" content="https://kesariglow.in/og-image.jpg" />

      {/* Additional Meta Tags */}
      <meta name="author" content="Kesari Glow" />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="language" content="English" />
      <meta name="geo.region" content="IN" />
      <meta name="geo.position" content="20.5937;78.9629" />
      <meta name="ICBM" content="20.5937, 78.9629" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="Global" />
      <meta name="rating" content="General" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Kesari Glow",
            "alternateName": "kesariglow.in",
            "description": "Premium Indian skincare and cosmetics brand",
            "url": "https://kesariglow.in",
            "logo": "https://kesariglow.in/logo.png",
            "sameAs": [
              "https://www.instagram.com/kesariglowofficial?igsh=YjY4YjZicjcyMW9j",
              "https://www.facebook.com/share/14DYDJxdryD/",
              "https://www.linkedin.com/company/kesariglow/"
            ],
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "G-17, OPPO. NAVJIVAN HOTEL, SHIV PLAZA, Gadhpur Rd",
              "addressLocality": "Surat",
              "addressRegion": "Gujarat",
              "postalCode": "395010",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "21.2335",
              "longitude": "72.8643"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+919898846514",
              "contactType": "customer service",
              "email": "support@kesariglow.in",
              "areaServed": ["IN", "Worldwide"],
              "availableLanguage": ["English", "Hindi", "Gujarati"]
            }
          }
        `}
      </script>

      {/* Additional LocalBusiness Schema */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Kesari Glow",
            "image": "https://kesariglow.in/logo.png",
            "priceRange": "₹₹",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "G-17, OPPO. NAVJIVAN HOTEL, SHIV PLAZA, Gadhpur Rd, near SHYAMDHAM MANDIR, Laxmi Nagar, VARACHHA",
              "addressLocality": "Surat",
              "addressRegion": "Gujarat",
              "postalCode": "395010",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "21.2335",
              "longitude": "72.8643"
            },
            "url": "https://kesariglow.in",
            "telephone": "+919898846514",
            "email": "support@kesariglow.in",
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
              ],
              "opens": "10:00",
              "closes": "19:00"
            }
          }
        `}
      </script>
    </Helmet>
  );
} 